(function($, Drupal) {
    'use strict';

    const {PATH} = Drupal.theme;

    if ($('#google-container').length) {
        const $latitude = 45.8320108;
        const $longitude = 1.2585262999999713;
        const $mapZoom = 17;

        const dataUrl = PATH + '/images/gmap_marker.png';

        const style = [{
            'elementType': 'geometry',
            'stylers': [{'color': '#F5F5F5'}],
        }, {
            'elementType': 'labels.icon',
            'stylers': [{'visibility': 'off'}],
        }, {
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#616161'}],
        }, {
            'elementType': 'labels.text.stroke',
            'stylers': [{'color': '#F5F5F5'}],
        }, {
            'featureType': 'administrative.land_parcel',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#BDBDBD'}],
        }, {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [{'color': '#F4F4F4'}],
        }, {
            'featureType': 'poi',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#757575'}],
        }, {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [{'color': '#B7CA79'}],
        }, {
            'featureType': 'poi.park',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#404040'}],
        }, {
            'featureType': 'road',
            'elementType': 'geometry',
            'stylers': [{'color': '#FFFFFF'}],
        }, {
            'featureType': 'road.arterial',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#404040'}],
        }, {
            'featureType': 'road.highway',
            'elementType': 'geometry',
            'stylers': [{'color': '#DADADA'}],
        }, {
            'featureType': 'road.highway',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#404040'}],
        }, {
            'featureType': 'road.local',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#7C7C7C'}],
        }, {
            'featureType': 'transit.line',
            'elementType': 'geometry',
            'stylers': [{'color': '#E5E5E5'}],
        }, {
            'featureType': 'transit.station',
            'elementType': 'geometry',
            'stylers': [{'color': '#EEEEEE'}],
        }, {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [{'color': '#C9C9C9'}],
        }, {
            'featureType': 'water',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#9E9E9E'}],
        }];

        // Set google map options
        const mapOptions = {
            center: new google.maps.LatLng($latitude, $longitude),
            zoom: $mapZoom,
            panControl: false,
            zoomControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            styles: style,
        };

        // Initialize the map
        const map = new google.maps.Map(document.getElementById('google-container'), mapOptions);

        // Add Marker
        new google.maps.Marker({
            map: map,
            position: map.getCenter(),
            icon: {
                url: dataUrl,
                size: new google.maps.Size(335, 65),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(70, 70),
            },
        });

        const zoomControlDiv = document.createElement('div');
        new CustomZoomControl(zoomControlDiv, map);
        // insert the zoom div on the top left of the map
        map.controls[google.maps.ControlPosition.LEFT_TOP].push(zoomControlDiv);
    }

    /**
     * Add custom buttons for the zoom-in/zoom-out on the map
     * @param {string} controlDiv
     * @param {string} map
     * @constructor
     */
    function CustomZoomControl(controlDiv, map) {
    // Grap the zoom elements from the DOM and insert them in the map
        const controlUIzoomIn = document.getElementById('cd-zoom-in');
        const controlUIzoomOut = document.getElementById('cd-zoom-out');
        controlDiv.appendChild(controlUIzoomIn);
        controlDiv.appendChild(controlUIzoomOut);
        /*
         * Setup the click event listeners and zoom-in or out according
         * to the clicked element
         */
        google.maps.event.addDomListener(controlUIzoomIn, 'click', function() {
            map.setZoom(map.getZoom() + 1);
        });
        google.maps.event.addDomListener(controlUIzoomOut, 'click', function() {
            map.setZoom(map.getZoom() - 1);
        });
    }
})(jQuery, Drupal);
